

























































































































































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DataDokter from "@/services/DataUtility";
import DataSKDP from "@/services/DataSKDP";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeSKDP } from "@/store/modules/skdp";
import { storeSoap } from "@/store/modules/soap";
import moment from "moment";
import TglKontrolSkdpDatePicker from "@/components/form_components/TglKontrolSkdpDatePicker.vue";
import VCDatePicker from "@/components/form_components/VCDatePicker.vue";
import { storePasien } from "@/store/modules/pasien";
import Skdp from "@/services/new/Skdp";
import MasterReferensi from "@/store/modules/new/MasterReferensi";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { PrefillSkdp } from "@/types/resumeRalanBlanko";
import { StatusKronisJkn } from "@/types/skdp";

@Component({
  components: {
    CardModalTtd,
    TglKontrolSkdpDatePicker,
    VCDatePicker
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardInputSKDP extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly register!: string;
  @Prop() dataSkdp!: string;
  @Prop() kronis!: string;
  @Prop({ default: null }) readonly prefill!: PrefillSkdp | null;
  @Prop({ default: false }) show: boolean;

  @Ref() readonly ttd!: HTMLElement;
  @Ref() readonly diag!: HTMLInputElement;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  checkKronis = false;
  dokter = {};
  diagnosis = "";
  alasan = "";
  rtl = "";
  tglRujukan = "";
  tglKontrol = "";
  sess_login = userModule.user;
  listDokter = {};
  alert = "";
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  err = {};
  modalTtd = false;
  tglShowRujukan = false;
  tglShowKontrol = false;
  searchAlasan = null;
  entriesAlasan = [];
  searchRtl = null;
  entriesRtl = [];
  autofocus = false;
  hintTglKontrol = "";
  loadingTglKontrol = false;
  expandInput = false;
  saving = false;
  statusKronis: StatusKronisJkn | null = null;
  alasanKontrolDini = "";
  readonly PILIHAN_ALASAN_KONTROL_DINI = [
    "Belum stabil",
    "Evaluasi hasil pemeriksaan penunjang",
    "Evaluasi perubahan terapi",
    "Indikasi klinis lain"
  ];
  validasiAlasanKontrolDini = [
    v => !!(v && String(v).trim()) || "*Alasan kontrol lebih awal wajib diisi"
  ];

  get tglKontrolIso(): string {
    return this.tglKontrol ? moment(this.tglKontrol).format("YYYY-MM-DD") : "";
  }

  get kronisJkn(): boolean {
    return (
      !!this.statusKronis &&
      this.statusKronis.jkn &&
      (this.statusKronis.kronis_jkn || this.checkKronis)
    );
  }

  get perluAlasanKontrolDini(): boolean {
    return (
      this.kronisJkn &&
      this.tglKontrolIso !== "" &&
      this.tglKontrolIso < (this.statusKronis as StatusKronisJkn).tgl_kontrol_minimal
    );
  }

  get infoKronisJkn(): string {
    if (!this.kronisJkn || !this.statusKronis) {
      return "";
    }
    const prb = this.statusKronis.prb
      .map(p => `${p.kode} (${p.program})`)
      .join(", ");
    const dasar = prb
      ? `Pasien JKN dengan diagnosis PRB ${prb}`
      : "Pasien JKN kasus kronis";
    const tgl = moment(this.statusKronis.tgl_kontrol_minimal).format(
      "DD-MM-YYYY"
    );
    return `${dasar}: kontrol berikutnya bawaan ${this.statusKronis.hari_kontrol} hari (${tgl}). Kontrol lebih awal wajib diberi alasan.`;
  }

  @Watch("register")
  async muatStatusKronis(): Promise<void> {
    const register = this.register;
    this.statusKronis = null;
    if (!register) {
      return;
    }
    const status = await Skdp.statusKronis(register);
    if (register === this.register) {
      this.statusKronis = status;
      this.terapkanBawaanKronis();
    }
  }

  @Watch("checkKronis")
  terapkanBawaanKronis(): void {
    if (
      this.dataSkdp["id"] ||
      this.tglKontrol ||
      !this.kronisJkn ||
      !this.statusKronis
    ) {
      return;
    }
    const libur = new Set(
      MasterReferensi.holidays.map(h => moment(h.date).format("YYYY-MM-DD"))
    );
    const tanggal = moment(this.statusKronis.tgl_kontrol_minimal);
    for (
      let i = 0;
      i < 14 && (tanggal.day() === 0 || libur.has(tanggal.format("YYYY-MM-DD")));
      i++
    ) {
      tanggal.add(1, "day");
    }
    if (tanggal.format("YYYY-MM-DD") >= moment().format("YYYY-MM-DD")) {
      this.tglKontrol = tanggal.format("YYYY-MM-DD");
    }
  }

  get stateInputSkdp() {
    return storeSKDP.inputSkdp;
  }
  get stateSkdp() {
    return storeSKDP.skdp;
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get infoBpjs() {
    return RegisterKunjungan.infoBpjs;
  }

  get rujukanDaysRemaining() {
    return RegisterKunjungan.rujukanDaysRemaining;
  }

  get rujukanDaysWarn() {
    return 30;
  }

  mounted() {
    this.getDpjp();

    storeSKDP.act_autocomplete_alasan(this.searchAlasan);
    storeSKDP.act_autocomplete_rtl(this.searchRtl);

    if (MasterReferensi.holidays.length < 1) {
      MasterReferensi.getHolidays();
    }

    if (this.infoBpjs) {
      this.tglRujukan = this.infoBpjs.tglRujukan;
    }

    this.getSkdp();
    this.muatStatusKronis();
  }

  @Watch("dataSkdp")
  getSkdp() {
    if (this.dataSkdp["dokter"] == undefined) {
      this.dokter = { id: this.sess_login.id, nama: this.sess_login.nama };
      this.diagnosis = this.statesoapdetail[0]?.a;
      this.alasan = "";
      this.rtl = "";
      this.tglRujukan = this.infoBpjs ? this.infoBpjs.tglRujukan : "";
      this.tglKontrol = "";
      this.alasanKontrolDini = "";
      if (this.kronis == "1") {
        this.checkKronis = true;
      } else {
        this.checkKronis = false;
      }

      if (this.sess_login.unit_group_id == "27") {
        this.alasan = "Belum stabil";

        if (this.kronis == "1") {
          this.rtl = this.statesoapdetail[0]?.p;
        } else {
          this.rtl = "Kontrol rutin";
        }
      }

      this.terapkanPrefill();
    } else {
      this.dokter = this.dataSkdp["dokter"];
      this.diagnosis = this.dataSkdp["diagnosis"];
      this.alasan = this.dataSkdp["alasan"];
      this.rtl = this.dataSkdp["rtl"];
      this.tglRujukan = this.dataSkdp["tgl_rujukan"];
      this.tglKontrol = this.dataSkdp["tgl_kunjungan"];
      this.checkKronis = this.dataSkdp["kasus_kronis"];
      this.alasanKontrolDini = this.dataSkdp["alasan_kontrol_dini"] || "";
    }
    this.terapkanBawaanKronis();
  }

  terapkanPrefill() {
    const p = this.prefill;
    if (!p) return;

    if (p.diagnosis) {
      this.diagnosis = p.diagnosis;
    }

    if (p.tgl_kontrol) {
      this.tglKontrol = p.tgl_kontrol;
    }

    if (p.dpjp_id) {
      const daftar: any = this.listDokter;
      const dpjp = Array.isArray(daftar)
        ? daftar.find((d: any) => String(d.id) === String(p.dpjp_id))
        : null;

      if (dpjp) {
        this.dokter = dpjp;
      }
    }
  }

  @Watch("prefill")
  onPrefill() {
    this.terapkanPrefill();
  }

  passTtd(value) {
    this.$emit("passTtd", value);
  }

  getDpjp() {
    const dktr = DataDokter.getListDokter();
    dktr.then(dktr => {
      this.listDokter = dktr;
      this.terapkanPrefill();
    });
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get input() {
    return {
      register_id: this.register,
      pasien_rm: this.statePasien.rm,
      dpjp_id: this.dokter["id"],
      unit_id: this.sess_login["unit_id"],
      tgl_rujukan: this.tglRujukan,
      diagnosis: this.diagnosis,
      alasan: this.alasan,
      rtl: this.rtl,
      tgl_kunjungan: this.tglKontrolIso || this.tglKontrol,
      user_id: this.sess_login["id"],
      kasus_kronis: this.checkKronis ? "1" : "0",
      alasan_kontrol_dini: this.perluAlasanKontrolDini
        ? String(this.alasanKontrolDini || "").trim()
        : null
    };
  }

  simpanSKDP() {
    if (this.readOnly) return;
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      if (!this.saving) {
        this.saving = true;

        const resp = this.dataSkdp["id"]
          ? Skdp.update(this.dataSkdp["id"], this.input)
          : Skdp.create(this.input);

        resp
          .then(dt => {
            if (dt["status"] == 1) {
              storeSKDP.actSkdp_on_reg(this.register);
              storeSKDP.actSKD_on_id(dt["data"].id);
              appModule.NoticeDelay("Berhasil Simpan SKDP");
              this.close();
            }
          })
          .catch(() => {
            this.muatStatusKronis();
          })
          .finally(() => {
            this.saving = false;
          });

        this.saving = true;
      }
    }
  }

  close() {
    this.expandInput = false;
    this.$emit("close", this.expandInput);
  }

  get stateAlasan() {
    return storeSKDP.alasan.map(alasan => {
      return alasan.text;
    });
  }

  get stateRtl() {
    return storeSKDP.rtl.map(rtl => {
      return rtl.text;
    });
  }

  @Watch("searchAlasan", { deep: true })
  searchedAlasan(val) {
    if (val === null || val.length < 2) return;
    else {
      this.alasan = val;
    }

    if (this.alasan === this.searchAlasan) return;
  }

  @Watch("searchRtl", { deep: true })
  searchedRtl(val) {
    if (val === null || val.length < 2) return;
    else {
      this.rtl = val;
    }

    if (this.rtl === this.searchRtl) return;
  }

  @Watch("tglKontrol")
  changeTglKontrol(val) {
    if (!val) {
      this.hintTglKontrol = "";
    }
  }

  setTglKontrol(val) {
    this.tglKontrol = val;
  }
}
